import { FC, useEffect } from 'react'
import { Helmet } from 'react-helmet-async';
import {
  Box,
  Container,
  Theme,
  Typography,
} from '@mui/material';
import AuthBanner from '../../components/authentication/AuthBanner';
import { SxProps } from '@mui/system';


const LayoutPlain: FC<{ sx?: SxProps<Theme>, withSiginIn?:boolean }> = ({ 
  children, 
  sx: customSx,
  withSiginIn,
}) => {
  useEffect(() => {
    let recaptchaBadge = document.querySelector('.grecaptcha-badge')
    if (recaptchaBadge) {
      recaptchaBadge.remove()
      recaptchaBadge = null
    }
  }, [])

  const year = new Date().getFullYear()
  return (
    <>
      <Helmet>
        <title>Register | OnData</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          position: 'relative',
          ...(customSx || {}),
        }}
      >
        <AuthBanner withSiginIn={withSiginIn} />
        <Container
          maxWidth="lg"
          sx={{ py: '20px' }}
        >
          {children}
        </Container>
        <Typography
          color='textSecondary'
          variant='body2'
          sx={{ 
            position: 'absolute', 
            bottom: '0.4em',
            left: 'calc(50% - 12em)',
          }}
        >
          Copyright &copy; 2021{year > 2021 && `-${year}`} OnData, Inc. All rights reserved.
        </Typography>
      </Box>
    </>
  );
}

export default LayoutPlain
